import * as z from "zod";

export const syncShopifyOrdersStatus = {
  name: "syncShopifyOrdersStatus" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ status: z.string() }),
};
